import { render, staticRenderFns } from "./CreateTransactionForm.vue?vue&type=template&id=54c144f9"
import script from "./CreateTransactionForm.vue?vue&type=script&lang=js"
export * from "./CreateTransactionForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTransactionForm.vue?vue&type=style&index=0&id=54c144f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports